import {makeAutoObservable, runInAction} from 'mobx';

import type {CoreClientChannelsPostsCountParams} from '../../../../api/types/core/methods';
import type {RpcRequest} from '../../../../api/utils/apiRequest';
import type {AttachmentType, Config} from './types';

import {apiRequest} from '../../../../api/utils/apiRequest';
import {buildQuery} from './utils';

export class ChannelAttachmentsStore {
  static AVAILABLE_ATTACHMENT_TYPES: AttachmentType[] = [
    'image',
    'document',
    'audio',
    'url',
  ];
  availableAttachmentTypes: AttachmentType[] = [];
  channelId: Config['channelId'];
  isLoaded = false;

  constructor(config: Config) {
    this.channelId = config.channelId;

    makeAutoObservable(
      this,
      {},
      {
        autoBind: true,
      },
    );

    this.fetchAvailableAttachmentTypes();
  }

  private async fetchAvailableAttachmentTypes() {
    try {
      const result = await apiRequest<CoreClientChannelsPostsCountParams>({
        batch: ChannelAttachmentsStore.AVAILABLE_ATTACHMENT_TYPES.map(type => {
          const request: RpcRequest<CoreClientChannelsPostsCountParams> = {
            method: 'client.channels.posts.count',
            params: {
              channel_id: this.channelId,
              query: buildQuery(type),
            },
          };

          return request;
        }),
      });

      ChannelAttachmentsStore.AVAILABLE_ATTACHMENT_TYPES.forEach((type, i) => {
        if (result[i]._count) {
          runInAction(() => {
            this.availableAttachmentTypes.push(type);
          });
        }
      });

      runInAction(() => {
        this.isLoaded = true;
      });
    } catch (error) {
      // do nothing
    }
  }
}
